export const CATEGORICAL = "categorical";
export const HIERARCHICAL = "hierarchical";
export const QUANTITATIVE = "quantitative";
export const RELATIVE_DATE = "relative_date";
